import { HelpMessage } from 'utils/constants'
import { CIMSColumn } from '../../CIMSColumn/types'

/**
 *  This is a hook to add a description column configuration to a CIMS table instance
 *
 *  @param entityName the name of the entity that will appear in the help text
 *
 *  @example
 *    useOptionalDescriptionColumn('Non User Email')
 */
export function useOptionalDescriptionColumn<
  T extends { description?: string | null }
>(entityName: string): CIMSColumn<T> {
  return {
    title: 'Description',
    render: ({ description }) => description,
    width: 400,
    help: HelpMessage.Description(entityName),
    filter: {
      type: 'search',
      with: 'callback',
      onFilter: (value, { description }) => {
        if (!description) return false
        return description
          .toLowerCase()
          .includes(value.toString().toLowerCase())
      },
    },
  }
}
